import { HttpAction, HttpStateData, handleHttpError, performHttpRequest } from '@/clients/http'
import { createHttpRequest } from '@/clients/redux/actions/http'
import {
  CreateRequestUrlParams,
  RequestParamsObject,
  RequestQueryObject,
  createRequestUrl,
} from '@/utils'

export interface ModelProperties {
  correlations: {
    [key: string]: string
  }
  endpoints: {
    [key: string]: string
  }

  createEndpoint?(options: CreateRequestUrlParams<RequestQueryObject, RequestParamsObject>): string
  createHttpRequest?(options: HttpAction): Promise<any>
}

export class Model implements ModelProperties {
  correlations = {}
  endpoints = {}

  public static createEndpoint<Q, P>(options: CreateRequestUrlParams<Q, P>): string {
    return createRequestUrl(options)
  }

  public static async createHttpRequest<Data, Error = {}>(
    options: HttpAction
  ): Promise<HttpStateData<Data, Error>> {
    const { store: storeInRedux = false, ...httpActionProps } = options

    if (storeInRedux) {
      return createHttpRequest<Data, Error>(httpActionProps)
    }

    return new Promise((resolve) => {
      const formattedResponse = {
        correlationKey: options?.correlationKey,
        loading: false,
        success: false,
        error: null,
        payload: options?.payload?.body,
        data: null,
      } as HttpStateData<Data, Error>

      performHttpRequest(httpActionProps['payload'])
        .then((response) => {
          formattedResponse.success = true
          formattedResponse.data = response?.data
          resolve(formattedResponse)
        })
        .catch((e) => {
          formattedResponse.success = false
          formattedResponse.error = e?.response ?? e

          handleHttpError(e)

          resolve(formattedResponse)
        })
    })
  }
}
